import { Box } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '3px',
    height: 'auto'
  }
}))

const Cards = props => {
  const classes = useStyles()
  const { className, children, ...remainingProps } = props
  return <Box className={`${classes.root} ${className}`} {...remainingProps}>{children}</Box>
}

export default Cards